import { getAssignmentType, getChecklistSchedule } from '../../../core/utils/checklistEventAssignment';

interface ChecklistScheduleEvent {
	checklistTemplate?: { label?: string; type?: string };
	checklistSchedule?: {
		assignmentType?: string;
		assignee?: { firstName?: string; lastName?: string; first_name?: string; last_name?: string } | null;
		group?: { label?: string } | null;
	};
}

export function getChecklistOwnerName(type?: string): string {
	if (type === 'workplace') return 'Workplace';
	if (type === 'organization') return 'Organization';
	return '-';
}

export function getChecklistAssignedDisplay(item: ChecklistScheduleEvent): string {
	const schedule = getChecklistSchedule(item);
	if (!schedule) return 'Unassigned';

	const assignmentType = getAssignmentType(schedule);
	if (assignmentType === 'group') {
		const group = schedule.group as { label?: string } | undefined;
		return group?.label || 'Unassigned Group';
	}

	if (assignmentType === 'assignee') {
		const assignee = schedule.assignee as Record<string, unknown> | string | null | undefined;
		if (assignee && typeof assignee === 'object') {
			const firstName = String(assignee.firstName ?? assignee.first_name ?? '');
			const lastName = String(assignee.lastName ?? assignee.last_name ?? '');
			return `${firstName} ${lastName}`.trim() || 'Unassigned';
		}
		return 'Unassigned';
	}

	return 'Unassigned';
}

export function formatChecklistDateTimeFromAPI(
	dateFormatted: string,
	timeFormatted: string,
): string {
	const dateParts = dateFormatted.split('/');
	if (dateParts.length !== 3) return `${dateFormatted} ${timeFormatted}`;

	const [month, day, year] = dateParts;
	const timeParts = timeFormatted.trim().split(/\s+/);
	const clock = timeParts[0] || '';
	const ampm = (timeParts[1] || '').toUpperCase();
	const [hStr, mStr, sStr] = clock.split(':');
	let hours = Number(hStr) || 0;
	const minutes = Number(mStr) || 0;
	const seconds = Number(sStr) || 0;

	if (ampm === 'PM' && hours < 12) hours += 12;
	if (ampm === 'AM' && hours === 12) hours = 0;

	const date = new Date(Number(year), Number(month) - 1, Number(day), hours, minutes, seconds);
	return date.toLocaleString('en-US', {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		second: '2-digit',
		hour12: true,
	});
}
